module.exports = __webpack_public_path__ + "img/mastercard.a3c428f0.png";